module.exports = __webpack_public_path__ + "11b6d2a0d3658a96c170ea177570d7a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gilles-harmonica.png
// module id = 2043
// module chunks = 0